import { IndustriaDestinoEntity } from "src/app/pages/_user/industria-destino/industria-destino.entity"

export const autoCompleteCategoriaIndustriaOutPut = (value: string | number, row: IndustriaDestinoEntity) => {
    if (!row) {
      return { nomeIndustria: value }
    }
    return { industriaId: row.id }
  }